import { formatToIso } from "@repo/utils";
import useSWR from "swr";

import * as fetcher from "../fetcher";
import { setCommonSearchParams } from "./commonSearchProps";
import {
  type WorkOrderSearchProps,
  type WorkOrderSearchResponse,
} from "./types";

const stringifyWorkOrderQuery = (props?: WorkOrderSearchProps): string => {
  if (!props) {
    return "";
  }

  const searchParams = new URLSearchParams();

  setCommonSearchParams(searchParams, props);

  if (props.status?.length) {
    searchParams.set("status", props.status.join(","));
  }

  if (
    Array.isArray(props.scheduledStartTime) &&
    props.scheduledStartTime.length === 2
  ) {
    const formatted = props.scheduledStartTime.map((date) =>
      formatToIso(new Date(date))
    );
    searchParams.set("scheduledStartTime", formatted.join("-"));
  }

  if (props.measurementFilesUploaded !== undefined) {
    searchParams.set(
      "measurementFilesUploaded",
      String(props.measurementFilesUploaded)
    );
  }

  return searchParams.toString();
};

export function useWorkOrderSearch(searchSettings?: any) {
  const queryString = searchSettings
    ? stringifyWorkOrderQuery(searchSettings)
    : "";
  return useSWR<WorkOrderSearchResponse>(
    searchSettings ? `/opportunities/service-work-orders?${queryString}` : null,
    (url) => fetcher.core.get(url),
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    }
  );
}
